// export const Box = () => {
//   return (
//     <div
//       className="relative w-[846px] h-[626px]"
//       data-model-id="3125:6281-frame"
//     >
//       <div className="fixed top-[2134px] left-[calc(50.00%_+_495px)] w-[846px] h-[626px]">
//         <img
//           className="absolute top-0 left-[calc(50.00%_-_219px)] w-[537px] h-[626px]"
//           alt="Group"
//           src="/img/group-2085663674.svg"
//         />

//         <div className="absolute top-[415px] left-[calc(50.00%_-_219px)] w-[642px] h-[211px] bg-[linear-gradient(180deg,rgba(255,255,255,0)_0%,rgba(255,255,255,1)_100%)]" />

//         <img
//           className="absolute top-[254px] left-[-89px] w-[586px] h-[300px]"
//           alt="Group"
//           src="/img/group-2085663659.svg"
//         />

//         <div className="absolute w-[3.90%] h-[6.01%] top-[61.50%] left-[5.56%]">
//           <img
//             className="absolute w-full h-full top-0 left-0"
//             alt="Vector"
//             src="/img/vector.svg"
//           />

//           <img
//             className="absolute w-[39.30%] h-[87.58%] top-[12.42%] left-[60.70%]"
//             alt="Vector"
//             src="/img/vector-1.svg"
//           />

//           <img
//             className="absolute w-[62.53%] h-[9.39%] top-[90.61%] left-[37.47%]"
//             alt="Vector"
//             src="/img/vector-2.svg"
//           />
//         </div>
//       </div>
//     </div>
//   );
// };






export const BusinessProfileSection = () => {
  const features = [
    "Build your own branded business profile",
    "Grow a list of loyal followers who get notified",
    "Send push notifications directly to your followers",
    "Track engagement and see who loves your brand",
  ];

  return (
    <div>
      <div className="hidden lg:block">
        <section className="w-full flex justify-center px-12 py-10 bg-[#F7F7F7]">
  <div className="w-full max-w-[1700px]">
    <div className="bg-white rounded-[40px] shadow-lg grid grid-cols-2 gap-16 items-center"
      style={{
        padding: 'clamp(32px, calc(32px + (48 - 32) * ((100vw - 1199px) / (1943 - 1199))), 48px)',
      }}
    >

      {/* LEFT CONTENT */}
      <div>

        {/* label */}
        <div className="flex items-center gap-3 mb-6">
          <span className="w-3 h-3 bg-red-600 rounded-full"></span>
          <span className="text-gray-700 text-[16px]">Business Profile</span>
        </div>

        {/* heading */}
        <h2
          className="leading-[1.1] font-medium text-gray-900 mb-6"
          style={{
            fontSize: 'clamp(38px, calc(38px + (48 - 38) * ((100vw - 1199px) / (1943 - 1199))), 48px)',
          }}
        >
          Build a Loyal Following.
          <br />
          Keep Them <br />
          <span className="text-red-600"> Coming Back.</span>
        </h2>

        {/* description */}
        <p className="text-gray-600 leading-[28px] mb-8 max-w-[520px]"
          style={{
            fontSize: 'clamp(15px, calc(15px + (18 - 15) * ((100vw - 1199px) / (1943 - 1199))), 18px)',
          }}
        >
          Turn one-time deal seekers into loyal regulars. Your offers appear at
          the top of your followers' feeds for maximum visibility, and send
          targeted push notifications to drive immediate foot traffic.
        </p>

        {/* feature list */}
        <ul className="space-y-4">
          {features.map((item, index) => (
            <li key={index} className="flex items-center gap-3">
              <span className="flex items-center justify-center w-6 h-6 bg-red-600 rounded-full mt-[4px]">
                <span className="w-2 h-2 bg-white rounded-full"></span>
              </span>
              <span
                className="text-gray-700"
                style={{
                  fontSize: 'clamp(14px, calc(14px + (17 - 14) * ((100vw - 1199px) / (1943 - 1199))), 17px)',
                }}
              >
                {item}
              </span>
            </li>
          ))}
        </ul>

      </div>

      {/* RIGHT PHONE MOCKUP */}
      <div className="relative flex justify-end w-full"
        style={{
          right: 'clamp(0px, calc(0px + (32 - 0) * ((100vw - 1199px) / (1943 - 1199))), 32px)',
        }}
      >

        {/* phone image */}
        <img
          src="/images/Webp/Mobile4.webp"
          alt="Business profile phone"
          style={{
            width: 'clamp(520px, calc(320px + (420 - 320) * ((100vw - 1199px) / (1943 - 1199))), 420px)',
          }}
        />

        {/* floating notification */}
        <div
          className="
            absolute top-1/2 
            flex items-center gap-4
            px-5 py-4
            rounded-[26px]
            transbox
            backdrop-blur-xl
            border-4 border-solid border-white
            shadow-[0px_40px_80px_rgba(0,0,0,0.18)]
            animate-floatSlowDelay
            z-20
          "
          style={{
            left: 'clamp(-6px, calc(-6px - (40) * ((100vw - 1199px) / (1943 - 1199))), -46px)',
          }}
        >

          <img
            src="/images/Alert.svg"
            className="rounded-[15px] object-cover border-2 border-white"
            style={{
              width: 'clamp(52px, calc(52px + (64 - 52) * ((100vw - 1199px) / (1943 - 1199))), 64px)',
              height: 'clamp(52px, calc(52px + (64 - 52) * ((100vw - 1199px) / (1943 - 1199))), 64px)',
            }}
          />

          <div>
            <div
              className="font-regular text-black"
              style={{
                fontSize: 'clamp(15px, calc(15px + (18 - 15) * ((100vw - 1199px) / (1943 - 1199))), 18px)',
              }}
            >
              New deal from Bercelle!
            </div>
            <div className="text-sm text-gray-600 max-w-[220px]">
              Sent to 2.4K followers
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>

  <style>{`
    div.transbox {
      background-color: rgba(144, 42, 42, 0.47);
      -webkit-backdrop-filter: blur(5px);
      backdrop-filter: blur(5px);
      font-weight: bold;
    }
    
    @keyframes floatSlow {
      0%, 100% { transform: translateY(0px); }
      50% { transform: translateY(-16px); }
    }
    @keyframes floatSlowReverse {
      0%, 100% { transform: translateY(-10px); }
      50% { transform: translateY(10px); }
    }
    .animate-floatSlow { animation: floatSlow 6s ease-in-out infinite; }
    .animate-floatSlowDelay { animation: floatSlow 5s ease-in-out infinite; }
    .animate-floatSlowReverse { animation: floatSlowReverse 7s ease-in-out infinite; }
  `}</style>
</section>
      </div>

      <div className="block lg:hidden">
        <section className="w-full flex justify-center py-8 bg-white">

          <div className="w-full max-w-[1700px]">

            <div className=" bg-white  justify-center items-center">

              <div className="flex justify-center items-center  gap-2 text-white mb-6">
                <span className="w-2 h-2 bg-red-600 rounded-full"></span>
                <span className="text-[16px] text-gray-700">Deals by Category</span>
              </div>

              {/* heading */}
              <h2 className="text-[30px] text-center text-gray-900 mb-4 leading-tight px-4">
                Build a Loyal Following. Keep Them
                <span className="text-red-600"> Coming Back.</span>
              </h2>
              {/* LEFT CONTENT */}
              <div className="px-6" >

                {/* description */}
                <p className="text-gray-600 text-center text-[12px] mb-4 px-12 leading-relaxed">
                  Turn one-time deal seekers into loyal regulars. Your offers appear at the top of your followers' feeds for maximum visibility, and send targeted push notifications to drive immediate foot traffic.
                </p>

                {/* feature list */}



              </div>

              {/* RIGHT PHONE MOCKUP */}
              <div className="relative flex justify-center">

                {/* phone image */}
                <img
                  src="/images/Webp/Mobile4.webp"
                  alt="Business profile phone"
                  className="w-[320px]"
                />
                <div
                  className="
              absolute
              top-1/2
              
              flex
              items-center
              gap-4
              px-4
              py-5
              rounded-[26px]
              transbox
              backdrop-blur-xl
              border-4 border-solid border-white
              shadow-[0px_40px_80px_rgba(0,0,0,0.18)]
              animate-floatSlowDelay
              z-20 border
            "
                >

                  {/* PROFILE IMAGE */}
                  <img
                    src="/images/Alert.svg"
                    className="
      w-[48px]
      h-[48px]
      rounded-[15px]
      object-cover
      border-2 border-white
    "
                  />


                  {/* TEXT */}
                  <div>

                    <div className="font-regular text-[16px] text-black">
                      New deal from Bercelle!

                    </div>
                    <div className="text-[12px] text-gray-600 max-w-[220px]">
                      Sent to 2.4K followers
                    </div>

                  </div>

                </div>
                <div className="absolute bottom-[-160px] px-4 justify-center bottom-[-245px] z-30">
                  <div className="flex justify-center bg-[#F9F0F0] rounded-[24px] px-4 py-6 w-fit mb-4">
                    <ul className="space-y-4">

                      {features.map((item, index) => (
                        <li key={index} className="flex items-start gap-3">

                          <div className="
          w-4 h-4
          rounded-full
          bg-red-600
          flex items-center justify-center
        ">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="w-3 h-3 text-white"
                              viewBox="0 0 20 20"
                              fill="currentColor"
                            >
                              <path
                                fillRule="evenodd"
                                d="M16.704 5.29a1 1 0 010 1.42l-7.25 7.25a1 1 0 01-1.42 0l-3.25-3.25a1 1 0 111.42-1.42l2.54 2.54 6.54-6.54a1 1 0 011.42 0z"
                                clipRule="evenodd"
                              />
                            </svg>
                          </div>

                          <span className="text-gray-700 text-[14px]">
                            {item}
                          </span>

                        </li>
                      ))}

                    </ul>
                  </div></div>
              </div>

            </div>

          </div>

          <style>{`

   

div.transbox {
  background-color: rgba(144, 42, 42, 0.47);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  
  font-weight: bold;
}


        
        @keyframes floatSlow {
          0%,100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-16px);
          }
        }

        @keyframes floatSlowReverse {
          0%,100% {
            transform: translateY(-10px);
          }
          50% {
            transform: translateY(10px);
          }
        }

        .animate-floatSlow {
          animation: floatSlow 6s ease-in-out infinite;
        }
          .animate-floatSlowDelay {
          animation: floatSlow 5s ease-in-out infinite;
        }

        .animate-floatSlowReverse {
          animation: floatSlowReverse 7s ease-in-out infinite;
        }

      `}</style>
        </section>
      </div>
    </div>

  );
};